import type { Locale } from '$lib/i18n/types';

export const MOUSEFLOW_WEBSITE_ID = `e83b685f-5bad-457d-a598-985e77d6beb6`;
export const DIDOMI_VENDOR_APP_ID = 'mouseflow-Xb9p86re';
export const MOUSEFLOW_ALLOWED_LOCALES: Locale[] = ['fr-FR', 'it-IT', 'de-DE', 'es-ES'] as const;
